import type {PayloadActionResponse} from 'typings/portaro.fe.types';
import {responseTypes} from '../constants/portaro.constants';
import type {ExceptionActionResponse} from 'typings/portaro.be.types';
import {isExceptionActionResponse, isObject} from 'shared/utils/types-utils';

export function createPayloadActionResponse<T>(payload: T): PayloadActionResponse<T> {
    return {
        finished: true,
        responseType: responseTypes.PAYLOAD,
        payload
    };
}

export function createAcknowledgeActionResponse(): ExceptionActionResponse {
    return {
        finished: true,
        responseType: responseTypes.ACKNOWLEDGE,
        simpleName: ModalWindowResponseSimpleName.ACKNOWLEDGE
    };
}

export function createInterruptActionResponse(): ExceptionActionResponse {
    return {
        finished: true,
        responseType: responseTypes.INTERRUPT,
        simpleName: ModalWindowResponseSimpleName.MANUAL_INTERRUPT
    };
}

export function isInterruptedActionResponse(actionResponse: unknown): boolean {
    return isObject(actionResponse)
        && isExceptionActionResponse(actionResponse)
        && actionResponse.finished
        && actionResponse.responseType === responseTypes.INTERRUPT
        && actionResponse.simpleName === ModalWindowResponseSimpleName.MANUAL_INTERRUPT;
}

export function isExceptionResponseOf(actionResponse: unknown, simpleName: string): boolean {
    return isObject(actionResponse)
        && isExceptionActionResponse(actionResponse)
        && actionResponse.finished
        && actionResponse.responseType === responseTypes.EXCEPTION
        && actionResponse.simpleName === simpleName;
}

export async function catchManualInterruption<E>(fn: () => Promise<E>): Promise<E> {
    try {
        return await fn();
    } catch (exceptionResponse) {
        if (!isInterruptedActionResponse(exceptionResponse)) {
            throw exceptionResponse;
        }
        return null;
    }
}

export enum ModalWindowResponseSimpleName {
    ACKNOWLEDGE = 'ModalWindowAcknowledge',
    MANUAL_INTERRUPT = 'ModalWindowManualInterrupt'
}